import React, { Component } from 'react';
import VolPlan from './volPlan';


class AllerRetouPlan extends Component {
  constructor(props) {
    super(props);
  }


    render() {
        return (
            <>
      
             
                <div className="aller__content px-3 d-flex flex-column">
                

                  <h4 className="d-flex plan__header__txt">Plan de vol ({this.props.type})</h4>

                  
      
                  <div className="plan__content mt-1 mt-md-3">
                    <VolPlan itineraries={this.props.itineraries} />
                    {/* <div className="plan__aeroChange d-flex mt-1 mt-md-4 mb-4">
                          <img className="aeroChange__icon" src="/imgs/vols/Groupe 392.svg" alt="" />
                          <div className="ml-3 pr-1 pr-sm-5">
                             <h6 className="plan__volChange">Changement d'Aéroport à Londres</h6>
                             <h6 className="opacity__items">Escale de nuit<br></br>21h45m</h6>
                          </div>
                    </div> */}
                    {/* <VolPlan itineraries={this.props.itineraries}/> */}
                  </div>
                  
                    

                </div>
            
            </>
        );
    }
}

export default AllerRetouPlan;
